export const ALM_SETTINGS = {
  description:
    "Connect Application Lifecycle Management tool to enable requirement traceability",
  jira: {
    label: "Jira",
    fields: [
      {
        key: "domain",
        label: "Jira Domain / URL",
        placeholder: "https://company.atlassian.net",
        type: "url",
      },
      {
        key: "email",
        label: "Email Address",
        placeholder: "user@company.com",
        type: "email",
      },
      {
        key: "token",
        label: "API Token",
        placeholder: "Enter Jira API Token",
        type: "password",
      },
    ],
  },
  /* ado: {
    label: "Azure DevOps (ADO)",
    fields: [
      {
        key: "organization",
        label: "Organization",
        placeholder: "Enter Organization Name",
      },
      {
        key: "project",
        label: "Project Name",
        placeholder: "Enter Project Name",
      },
      {
        key: "pat",
        label: "Personal Access Token (PAT)",
        placeholder: "Enter Azure PAT",
        type: "password",
      },
    ],
  }, */
};

export const TM_SETTINGS = {
  description:
    "Sync test cases and results with your preferred test management tool.",
  zephyrSquad: {
    label: "Zephyr Squad",
    fields: [
      {
        key: "accessKey",
        label: "API Access Key",
        placeholder: "Enter Zephyr Access Key",
        type: "password",
      },
      {
        key: "secretKey",
        label: "Client Secret",
        placeholder: "Enter Client Secret",
        type: "password",
      },
    ],
  },
  /* xray: {
    label: "Xray",
    fields: [
      {
        key: "clientId",
        label: "Client ID",
        placeholder: "Enter Xray Client ID",
      },
      {
        key: "clientSecret",
        label: "Client Secret",
        placeholder: "Enter Xray Client Secret",
        type: "password",
      },
    ],
  }, */
};
